<script>
// SOURCE: https://jsfiddle.net/Linusborg/1zdzu7k1/
// This component is required in order to add dynamic Vue
// components to the event sidebar.
// Reference array sent to dynamic staticRenderFns
import Vue from 'vue';
import Vuetify from 'vuetify';

export default {
  props: ['template'],
  data() {
    return {
      templateRender: null
    };
  },
  render(h) {
    if (!this.templateRender) {
      return h('div', 'loading...');
    } else {
      return this.templateRender();
    }
  },
  watch: {
    // Every time the template prop changes,
    // I recompile it to update the DOM.
    template: {
      immediate: true, // makes the watcher fire on first render, too.
      handler() {
        Vue.use(Vuetify);
        var res = Vue.compile(this.template);

        this.templateRender = res.render;

        // staticRenderFns belong in $options.
        this.$options.staticRenderFns = [];

        // Clean the cache of static elements.
        // This is a cache with the results from the staticRenderFns.
        this._staticTrees = [];

        // Fill it with the new staticRenderFns.
        for (var i in res.staticRenderFns) {
          this.$options.staticRenderFns.push(res.staticRenderFns[i])
        }
      }
    }
  }
};
</script>
